export const mockCustomPlanInvite = {
  planId: 'preview-plan-id',
  email: 'owner@acmecorp.com',
  customerLabel: 'Acme Corp',
  terms: {
    planName: 'Acme Custom',
    monthlyPrice: 350,
    billingCycle: 'monthly',
    annualDiscount: 20,
    limits: { employees: 25 },
    features: [
      'Unlimited appointments',
      '25 employees',
      'SMS notifications',
      'Customer portal',
      'Priority support',
      'Custom onboarding',
    ],
    customerNotes: 'Includes dedicated onboarding call',
  },
  expiresAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
};
